import { render } from "./NavbarCircleButton.vue?vue&type=template&id=c1fa430a&scoped=true"
import script from "./NavbarCircleButton.vue?vue&type=script&lang=js"
export * from "./NavbarCircleButton.vue?vue&type=script&lang=js"

import "./NavbarCircleButton.vue?vue&type=style&index=0&id=c1fa430a&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1fa430a"]])

export default __exports__